import { IConfigurationQuestion } from 'types/ConfigurationQuestion.types';
import { ITestExtraPriceQuestion } from 'types/Configuration.types';

// Maps the saved configuration's questions (server shape, with ids) into the
// local in-memory test shape (slug-based, no ids) used to seed the test editor.
export const mapServerQuestionsToTestQuestions = (
  questions: IConfigurationQuestion[]
): ITestExtraPriceQuestion[] =>
  questions.map((question) => ({
    label: question.label,
    is_required: question.is_required,
    is_active: question.is_active,
    slug: question.slug,
    options: (question.options || []).map((option) => ({
      label: option.label,
      price: option.price,
      is_default: option.is_default,
      slug: option.slug,
    })),
  }));
